import React from "react";
import Typewriter from "typewriter-effect";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import "@fontsource/raleway";
import styled, { keyframes } from "styled-components";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Highlight } from "@mui/icons-material";
import "@fontsource/great-vibes";
import { Shake, ShakeSlow } from "reshake";
import "@fontsource/titillium-web";
function AnimatedText({ text }) {
  const textArray = text.split("");

  return (
    <Wrapper>
      {textArray.map((char, index) => (
        <span
          id="user-detail-name"
          key={index}
          style={{
            // color: "rgb(211, 46, 101)",
            color: "#dae3e3",
            marginTop: "1rem",
            fontFamily: "Titillium Web",
            filter: "contrast(5)",
            opacity: "2",
            textShadow: "black 4px 5px",
            fontSize: "180%",
          }}
        >
          {char}
        </span>
      ))}
    </Wrapper>
  );
}

export default function Professional2() {
  return (
    <div id="home" className="nav-link home">
      <FLEX>
        <div
          className="text"
          style={{
            fontFamily: "Titillium Web",
            fontSize: "3rem",
            color: "rgb(37, 255, 106)",
            backgroundRepeat: "no-repeat",
            width: "100%",
            maxWidth: "500px",
            minWidth: "300px",
            fontWeight: "bold",
            opacity: "0.85",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            boxSizing: "border-box",
            lineHeight: "1rem",
            textShadow: "black 4px 5px",
          }}
        >
          <p style={{ marginBottom: "1rem" }}>
            <span
              style={{
                fontFamily: "Great Vibes",
                color: "rgb(255, 255, 255)",
                marginBottom: "1.5rem",
              }}
            >
              <div style={{ marginTop: "1%" }}>
                <ShakeSlow>
                  <h2 style={{ fontFamily: "Great_vibes" }}>Hi 👋🏽, </h2>
                  <span
                    style={{
                      fontFamily: "Great Vibes",
                      color: "rgb(255, 255, 255)",
                      marginBottom: "1.5rem",
                    }}
                  >
                    My name is{" "}
                  </span>
                </ShakeSlow>
              </div>
            </span>
            <AnimatedText text="TATHAGAT" />
          </p>
          <p style={{ marginBottom: "1rem" }}>
            {" "}
            <span
              style={{ fontFamily: "Great Vibes", color: "rgb(255, 255, 255)" }}
            >
              {" "}
            </span>
          </p>
        </div>
      </FLEX>
      <ShakeSlow r={1} h={1} v={1}>
        {/* <div
          style={{
            objectFit: "100%",
            backgroundColor: "#1b242f",
            display: "flex",
            alignItems: "center",
            padding: "1%",
            margin: "auto",
            boxShadow:
              "rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",

            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            className="gif"
            style={{
              backgroundImage: "url(./circular.gif)",
              color: "rgb(255, 255, 255)",
              width: "100%",
              maxWidth: "380px",
              minWidth: "300px",
              backgroundRepeat: "no-repeat",
              borderRadius: "50%",
              padding: "2rem",
              boxSizing: "border-box",
              backgroundPosition: "center",
              boxShadow:
                "rgba(25, 220, 136, 0.486) 0px 30px 60px -12px inset, rgba(117, 9, 99, 0.3) 0px 18px 36px -18px inset",
              marginRight: "8%",
              zIndex: "1",
              filter: "contrast(1.1)",
              margin: "auto",
              marginBottom: "3%",
              padding: "5%",
            }}
            data-aos="fade-left"
            data-aos-easing="ease-in-back"
            data-aos-offset="0"
          >
            <img
              src="./profession_gif.jpg"
              style={{
                height: "50%",
                borderRadius: "60%",
                width: "100%",
                zIndex: "-1",
                border: "5px solid rgba(237, 42, 221, 0.852) 0px 10px 12px",
                backgroundColor: "transparent",
                boxShadow:
                  "rgba(32, 178, 250, 0.852) 0px 19px 38px,rgb(10, 170, 167) 0px 10px 12px",
                filter: "contrast(4)",
              }}
            ></img>
          </div>
        </div> */}
      </ShakeSlow>
    </div>
  );
}
const FLEX = styled.div`
  background-image: url(./pyr-resize.gif);
  background-repeat: no-repeat;
  object-fit: contain;
  background-size: 100% 100%;
  margin-bottom: 3%;
  width: 100%;
  height: 90vh;
  display: flex;
  justify-content: space-between;
  padding-top: 2%;
  border-bottom: "20px solid #04c984";
  padding-bottom: 2%;
  box-shadow: #04ae72 0px 10px 20px, rgb(2, 94, 92) 0px 3px 6px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    justify-content: center;
    align-items: center;
  }

  .gif {
    margin-left: 5%;
  }

  .text {
    width: 65%;
    display: inline-block;
    margin: auto;
    line-height: 1rem;
    @media (max-width: 768px) {
      width: 100%;
      text-align: center;
      margin-bottom: 1rem;
      line-height: 1rem;
    }
  }

  p {
    margin: 0;
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.5rem;
    color: white;
    text-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      line-height: 1rem;
    }
  }

  .Typewriter {
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.5rem;
    color: rgb(37, 221, 95);
    text-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px;
    @media (max-width: 768px) {
      font-size: 1.5rem;
      line-height: 1rem;
    }
  }

  img {
    height: 100%;
    border-radius: 50%;
    width: 42%;
    opacity: 0.98;
    background-color: transparent;
    box-shadow: rgba(237, 103, 226, 0.852) 0px 19px 38px,
      rgb(4, 145, 143) 0px 10px 12px;
    @media (max-width: 768px) {
      width: 80%;
    }
  }
`;
const animateText = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100px) skewX(10deg) skewY(10deg) rotateZ(30deg);
    filter: blur(10px);
  }
  25% {
    opacity: 1;
    transform: translateY(0px) skewX(0deg) skewY(0deg) rotateZ(0deg);
    filter: blur(0px);
  }
  75% {
    opacity: 1;
    transform: translateY(0px) skewX(0deg) skewY(0deg) rotateZ(0deg);
    filter: blur(1px);
  }
  100% {
    opacity: 0;
    transform: translateY(-100px) skewX(10deg) skewY(10deg) rotateZ(30deg);
    filter: blur(10px);
  }
`;

const Wrapper = styled.span`
  display: inline-block;

  span {
    opacity: 0;
    display: inline-block;
    animation-name: ${animateText};
    animation-duration: 6s;
    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
  }

  span:nth-child(1) {
    animation-delay: 0.1s;
  }
  span:nth-child(2) {
    animation-delay: 0.2s;
  }
  span:nth-child(3) {
    animation-delay: 0.3s;
  }
  span:nth-child(4) {
    animation-delay: 0.4s;
  }
  span:nth-child(5) {
    animation-delay: 0.5s;
  }
`;

const move = keyframes`
  from { transform: translateX(0%); }
  to { transform: translateX(100%); }
`;
